import { Chip, type ChipProps } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { AssessmentStatus } from "@thalamos/haven-common";

const chipColourByStatus = {
  open: "info",
  submitted: "attention",
  returned: "warning",
  approved: "success",
  // Finished, as an approved assessment is.
  completed: "success",
} as const satisfies Record<AssessmentStatus, NonNullable<ChipProps["color"]>>;

/** Where an assessment has got to, as a pill in its status's colours. */
export const AssessmentStatusChip = ({
  status,
}: {
  status: AssessmentStatus;
}) => {
  const { t } = useTranslation();

  return (
    <Chip
      size="small"
      color={chipColourByStatus[status]}
      label={t(`personPage.assessments.status.${status}`)}
      sx={{ fontWeight: 600 }}
    />
  );
};
